import { useState } from 'react';

import { usePlan } from '@/plan';
import { readStored, writeStored } from '@/storage';
import { plural, useT } from '@/str';

const SEEN_KEY = 'plan_end_seen';
const WARN_DAYS = 7;

const today = () => new Date().toLocaleDateString('en-CA');

const DAY_MS = 86_400_000;

function calendarDaysUntil(until: string): number {
  const end = new Date(until);
  const now = new Date();
  const a = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const b = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  return Math.round((b - a) / DAY_MS);
}

export function PlanEnding() {
  const t = useT();
  const { plan } = usePlan();
  const [seen, setSeen] = useState(() => readStored(SEEN_KEY) === today());

  if (seen || plan.source !== 'everyone' || !plan.until) return null;
  const daysLeft = calendarDaysUntil(plan.until);
  if (daysLeft < 0 || daysLeft > WARN_DAYS) return null;

  const head =
    daysLeft === 0
      ? t.planEndToday
      : t.planEndHead
          .split('{n}')
          .join(String(daysLeft))
          .split('{u}')
          .join(plural(daysLeft, t.exp.uDay));

  return (
    <section
      data-block="plan-ending"
      role="status"
      className="bg-card border-border border-l-warn rounded-card flex flex-col gap-2 border border-l-4 px-4 py-3.75"
    >
      <span className="text-t15 font-extrabold">{head}</span>
      <span className="text-t12h text-muted-foreground">{t.planEndBody}</span>
      <button
        type="button"
        onClick={() => {
          writeStored(SEEN_KEY, today());
          setSeen(true);
        }}
        className="text-t13 text-accent-ink -my-1 min-h-11 self-start border-0 bg-transparent p-0 font-extrabold"
      >
        {t.planEndOk}
      </button>
    </section>
  );
}
